module.exports = __webpack_public_path__ + "dingbeauty-build/img/logo-default_ding.5d2202a1.svg";